export type SponsorAnnotationDetail = {
    id?: number | string;
    postId?: number | string | null;
    rightsholder?: {
        id?: number;
        name?: string;
        url?: string | null;
    };
    placement?: { name?: string };
    sponsor?: { name?: string };
    mvpScore?: number;
    sponsorMediaValue?: number;
};

type CarouselExposureSource = {
    id?: number | string | null;
    sponsorAnnotationsDetails?: SponsorAnnotationDetail[];
};

const stringifyId = (id?: number | string | null) =>
    id == null ? null : String(id);

const getAnnotationDedupeKey = (
    annotation: SponsorAnnotationDetail,
    fallbackIndex: number,
) => {
    const annotationId = stringifyId(annotation.id);
    return annotationId || `missing-id-${fallbackIndex}`;
};

export const getExposureAnnotationsForSlide = ({
    isCarousel,
    post,
    carouselSlides,
    activeSlide,
}: {
    isCarousel: boolean;
    post?: CarouselExposureSource;
    carouselSlides: CarouselExposureSource[];
    activeSlide?: CarouselExposureSource;
}): SponsorAnnotationDetail[] => {
    if (!isCarousel) return activeSlide?.sponsorAnnotationsDetails || [];

    const activeSlideId = stringifyId(activeSlide?.id);
    if (!activeSlideId) return [];

    const seenAnnotationIds = new Set<string>();

    return [post, ...carouselSlides]
        .flatMap(source => source?.sponsorAnnotationsDetails || [])
        .filter((annotation, index) => {
            const key = getAnnotationDedupeKey(annotation, index);
            if (seenAnnotationIds.has(key)) return false;
            seenAnnotationIds.add(key);
            return true;
        })
        .filter(annotation => stringifyId(annotation.postId) === activeSlideId);
};

export const getCarouselExposureDividerLabel = (activeSlideLabel: string) =>
    `${activeSlideLabel} Exposures`;
